import React from "react";
import { graphql, useFragment } from "react-relay";
import { useWorkspaceTodoEditRemoveFile } from "./useWorkspaceTodoEditRemoveFile";
import { useWorkspaceTodoEditRemoveImages } from "./useWorkspaceTodoEditRemoveImages";
import { useOpenFile } from "../../../../Files/useOpenFile";
import { WorkspaceTodoLinkedContent_todo$key } from "./__generated__/WorkspaceTodoLinkedContent_todo.graphql";
import { useOpenImagePicker } from "../../../../../components/mobile/useImageActionSheet";
import { LinkedContentInput } from "../../../../../components/LinkedContent/LinkedContentInput";
import { Box } from "arkh";

export function WorkspaceTodoLinkedContent(props: {
  todo: WorkspaceTodoLinkedContent_todo$key;
  addImage: (
    uri: string,
    { width, height }: { width: number; height: number }
  ) => void;
  openLinkFile: () => void;
  disabled?: boolean;
}) {
  const todo = useFragment(
    graphql`
      fragment WorkspaceTodoLinkedContent_todo on TodoWorkspace {
        id
        descriptionImages {
          id
          ...LinkedContentInput_images
        }
        descriptionFiles {
          id
          ...LinkedContentInput_files
        }
      }
    `,
    props.todo
  );

  const { openImagePicker } = useOpenImagePicker({
    onAddImage: props.addImage,
  });

  const removeFiles = useWorkspaceTodoEditRemoveFile();
  const removeImages = useWorkspaceTodoEditRemoveImages();
  const openFile = useOpenFile();

  return (
    <Box
      cornerRadiusBottomLeft="large"
      cornerRadiusBottomRight="large"
      color={props.disabled ? "transparent" : "surface-primary"}
    >
      <LinkedContentInput
        disabled={props.disabled}
        files={todo.descriptionFiles}
        images={todo.descriptionImages}
        openFile={openFile}
        removeFile={(id) => {
          removeFiles(todo.id, [id]);
        }}
        removeImage={(id) => {
          removeImages(todo.id, [id]);
        }}
        openLinkFile={props.openLinkFile}
        openImagePicker={openImagePicker}
      />
    </Box>
  );
}
